var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M33.391 42.156l-5.457 5.338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M24.401 43.865L6.568 61.288a4.005 4.005 0 00-.041 5.685l1.568 1.578a4.004 4.004 0 005.637.042l17.882-17.471-7.213-7.257z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke",
    cx: 48.05,
    cy: 26.381,
    fill: "none",
    rx: 21.587,
    ry: 21.113
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    strokeDasharray: "3,6,9,300",
    d: "M60.477 25.239c-.644-6.893-6.735-11.978-13.594-11.348-6.858.63-11.904 6.738-11.259 13.631.644 6.893 6.735 11.978 13.593 11.348 6.859-.63 11.904-6.738 11.26-13.631z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bc64f55c811cc0fe2971364fd8de3d20.svg";
export { ForwardRef as ReactComponent };